import * as React from 'react';
import Menu from '@mui/material/Menu';
import { Formik, Form } from 'formik';
import { IconButton, TextField, Typography, Button, Stack, Box, MenuItem } from '@mui/material';
import Iconify from '../Iconify';

const Filter = ({ toggleFilter, applyFilters }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div>
        <Box style={{ display: 'flex', justifyContent: 'end' }}>
          <IconButton onClick={handleClick}>
            <Iconify icon="ic:round-filter-list" />
            <Typography variant="h6"> Filter</Typography>
          </IconButton>

          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <Formik
              initialValues={{
                userId: '',
                clubId: '',
                name: '',
                isBlocked: '',
                phone: '',
                email: '',
                startDate: '',
                endDate: '',
                plan: '',
                completed: '',
                pending: '',
                privilegeCard: '',
              }}
              onSubmit={async (values) => {
                applyFilters(values);
              }}
            >
              {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                <Form style={{ padding: '10px' }}>
                  <Stack direction="column">
                    <Stack direction="row" spacing={1}>
                      <TextField
                        style={{ paddingBottom: '10px' }}
                        id="clubId"
                        name="clubId"
                        fullWidth
                        label="IF Number"
                        value={values.clubId}
                        onChange={handleChange}
                      />
                      <TextField
                        style={{ paddingBottom: '10px' }}
                        id="userId"
                        name="userId"
                        fullWidth
                        label="User ID"
                        value={values.userId}
                        onChange={handleChange}
                      />
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <TextField
                        style={{ paddingBottom: '10px' }}
                        fullWidth
                        id="name"
                        name="name"
                        label="Name"
                        value={values.name}
                        onChange={handleChange}
                      />
                      <TextField
                        select
                        style={{ paddingBottom: '10px' }}
                        fullWidth
                        id="isBlocked"
                        name="isBlocked"
                        label="Status"
                        value={values.isBlocked}
                        onChange={handleChange}
                      >
                        <MenuItem value="true">Blocked</MenuItem>
                        <MenuItem value="false">Active</MenuItem>
                      </TextField>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <TextField
                        style={{ paddingBottom: '10px' }}
                        fullWidth
                        id="email"
                        name="email"
                        type="email"
                        label="Email"
                        value={values.email}
                        onChange={handleChange}
                      />
                      <TextField
                        style={{ paddingBottom: '10px' }}
                        fullWidth
                        id="phone"
                        name="phone"
                        label="Phone"
                        value={values.phone}
                        onChange={handleChange}
                      />
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <TextField
                        select
                        style={{ paddingBottom: '10px' }}
                        fullWidth
                        id="completed"
                        name="completed"
                        label="Investment Completed"
                        value={values.completed}
                        onChange={handleChange}
                      >
                        <MenuItem value="RFC">RFC</MenuItem>
                        <MenuItem value="RPC">RPC</MenuItem>
                        <MenuItem value="BOTH">BOTH</MenuItem>
                      </TextField>
                      <TextField
                        select
                        style={{ paddingBottom: '10px' }}
                        fullWidth
                        id="pending"
                        name="pending"
                        label="Investment Pending"
                        value={values.pending}
                        onChange={handleChange}
                      >
                        <MenuItem value="RFC">RFC</MenuItem>
                        <MenuItem value="RPC">RPC</MenuItem>
                        <MenuItem value="BOTH">BOTH</MenuItem>
                      </TextField>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <TextField
                        select
                        style={{ paddingBottom: '10px' }}
                        fullWidth
                        id="plan"
                        name="plan"
                        label="Club"
                        value={values.plan}
                        onChange={handleChange}
                      >
                        <MenuItem value="RFC">RFC</MenuItem>
                        <MenuItem value="RPC">RPC</MenuItem>
                        <MenuItem value="BOTH">BOTH</MenuItem>
                      </TextField>
                      <TextField
                        select
                        style={{ paddingBottom: '10px' }}
                        fullWidth
                        id="privilegeCard"
                        name="privilegeCard"
                        label="Privilege Card"
                        value={values.privilegeCard}
                        onChange={handleChange}
                      >
                        <MenuItem value="ENABLED">Enabled</MenuItem>
                        <MenuItem value="NOT_ENABLED">Not Enabled</MenuItem>
                      </TextField>
                    </Stack>
                    <Stack direction={'row'} spacing={2}>
                      <TextField
                        type="date"
                        name="startDate"
                        label="Start Date"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={values.startDate}
                        onChange={handleChange}
                      />
                      <p style={{ paddingTop: '15px' }}>to</p>
                      <TextField
                        type="date"
                        name="endDate"
                        fullWidth
                        label="End Date"
                        InputLabelProps={{ shrink: true }}
                        value={values.endDate}
                        onChange={handleChange}
                      />
                    </Stack>

                    <Button variant="contained" type="submit" style={{ marginTop: '10px' }}>
                      Filter
                    </Button>
                  </Stack>
                </Form>
              )}
            </Formik>
          </Menu>
        </Box>
      </div>
    </>
  );
};

export default Filter;
